import { el, mount, onTap } from '../ui/dom.ts';
import { iconEl } from '../ui/icons.ts';
import { appMain, ensureAppShell, pageIntro } from '../ui/shell.ts';
import { navigate } from '../router.ts';
import { t } from '../i18n/index.ts';

// "Telefonunuzdan tamamlayın" — araç ekranının devretme yolu.
//
// Araç ekranında uzun bir M3U adresi, kullanıcı adı ve parola yazmak fiilen
// imkânsız; ödeme adımı da oraya ait değil. Bu ekran işi telefona devreder.
// Karekod yok: telefona yazılacak şey kısa bir adres, uzun bir bağlantı değil.
// Yine de ısrar eden için ikincil bir yol var — kapatmıyoruz, sadece kolay
// olanı öne alıyoruz.

interface Job {
  title: string;
  lead: string;
  path: string;
  steps: string[];
  fallbackLabel: string;
  fallbackPath: string;
}

function jobFor(kind: string, planCode: string): Job {
  if (kind === 'plan') {
    return {
      title: t('handoff.plan.title'),
      lead: t('handoff.plan.lead'),
      path: '/plans',
      steps: [
        t('handoff.step1'),
        t('handoff.step2'),
        planCode === 'plus' ? t('handoff.plan.step3plus') : t('handoff.plan.step3'),
      ],
      fallbackLabel: t('handoff.plan.fallback'),
      fallbackPath: `/plans?checkout=here&plan=${encodeURIComponent(planCode)}`,
    };
  }
  return {
    title: t('handoff.source.title'),
    lead: t('handoff.source.lead'),
    path: '/settings',
    steps: [t('handoff.step1'), t('handoff.step2'), t('handoff.source.step3')],
    fallbackLabel: t('handoff.source.fallback'),
    fallbackPath: '/settings?form=open',
  };
}

export function handoffView(_params: Record<string, string>, query: URLSearchParams): void {
  ensureAppShell();
  const host = appMain();
  const job = jobFor(query.get('task') ?? 'source', query.get('plan') ?? '');
  const url = location.origin + job.path;

  const fallback = el('button', { class: 'btn btn-quiet', type: 'button' }, job.fallbackLabel);
  onTap(fallback, () => navigate(job.fallbackPath));

  const back = el('button', { class: 'btn btn-outline', type: 'button' }, iconEl('arrowLeft'), t('handoff.back'));
  onTap(back, () => history.back());

  mount(host, el('div', { class: 'wrap' },
    pageIntro(job.title),
    el('div', { class: 'handoff' },
      el('div', { class: 'handoff-copy' },
        el('p', { class: 'lead' }, job.lead),
        el('div', { class: 'handoff-url' },
          el('small', {}, t('handoff.url')),
          el('b', {}, url.replace(/^https?:\/\//, '')),
        ),
        el('ol', { class: 'handoff-steps' }, ...job.steps.map((step) => el('li', {}, step))),
        el('div', { class: 'handoff-actions' }, back, fallback),
      ),
    ),
  ));
}
